import { BREAKPOINTS } from "../assets/constants/styles";
import { pxToRem } from "./helpers";

export const mediaQueries = {
  mobile: `@media (max-width: ${pxToRem(BREAKPOINTS.tablet - 1)})`,
  tablet: `@media (min-width: ${pxToRem(BREAKPOINTS.tablet)})`,
  laptop: `@media (min-width: ${pxToRem(BREAKPOINTS.laptop)})`,
  desktop: `@media (min-width: ${pxToRem(BREAKPOINTS.desktop)})`,
};

export const media = {
  mobile: (styles) => `${mediaQueries.mobile} { ${styles} }`,
  tablet: (styles) => `${mediaQueries.tablet} { ${styles} }`,
  laptop: (styles) => `${mediaQueries.laptop} { ${styles} }`,
  desktop: (styles) => `${mediaQueries.desktop} { ${styles} }`,
};
